import React, { ReactElement, useMemo } from 'react';

import { Token } from '@app/types/token';
import { Center, Flex, Spinner } from '@chakra-ui/react';
import { AddLiquidityV3 } from '@app/screens/liquidity/AddLiquidityV3';
import { useRouter } from 'next/router';
import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';
import AddLiquidityLayout from '@app/layouts/AddLiquidityLayout/AddLiquidityLayout';
import { NextPageWithLayout } from '@app/pages/_app';
import { getTokensWhitelist } from '@app/constants/tokensWhitelist';
import { useConfig } from '@app/config';

const LiquidityPageV4: NextPageWithLayout = () => {
  const router = useRouter();
  const { token0, token1 } = router.query;

  const config = useConfig();

  const TOKENS_WHITELIST = getTokensWhitelist(config);

  const initialData = useMemo(() => {
    if (!TOKENS_WHITELIST || !token0 || !token1) {
      return;
    }

    const _token0 = token0 as string;
    const _token1 = token1 as string;

    const tokenA =
      _token0 === NATIVE_TOKEN_ADDRESS
        ? {
            symbol: 'ETH',
            decimals: 18,
            name: 'ETH',
            contractAddress: NATIVE_TOKEN_ADDRESS,
            logoUri: ''
          }
        : TOKENS_WHITELIST.find(
            item => item.contractAddress.toLowerCase() === _token0.toLowerCase()
          );
    const tokenB =
      _token1 === NATIVE_TOKEN_ADDRESS
        ? {
            symbol: 'ETH',
            decimals: 18,
            name: 'ETH',
            contractAddress: NATIVE_TOKEN_ADDRESS,
            logoUri: ''
          }
        : TOKENS_WHITELIST.find(
            item => item.contractAddress.toLowerCase() === _token1.toLowerCase()
          );

    if (!tokenA || !tokenB) {
      return;
    }

    return {
      from: {
        amount: '',
        token: {
          symbol: tokenA.symbol,
          decimals: +tokenA.decimals,
          name: tokenA.name,
          contractAddress: tokenA.contractAddress,
          logoUri: ''
        } satisfies Token
      },
      to: {
        amount: '',
        token: {
          symbol: tokenB.symbol,
          decimals: +tokenB.decimals,
          name: tokenB.name,
          contractAddress: tokenB.contractAddress,
          logoUri: ''
        } satisfies Token
      }
    };
  }, [TOKENS_WHITELIST, token0, token1]);

  if (token0 && token1 && !initialData) {
    return (
      <Flex
        w="100%"
        h="100%"
        minHeight="calc(100vh - 200px)"
        justifyContent="center"
      >
        <Center>
          <Spinner color="orange" width={8} height={8} />
        </Center>
      </Flex>
    );
  }

  return <AddLiquidityV3 initialData={initialData} />;
};

LiquidityPageV4.getLayout = function getLayout(page: ReactElement) {
  return <AddLiquidityLayout>{page}</AddLiquidityLayout>;
};

export default LiquidityPageV4;
